import React from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import PinIndicator from 'src/view/components/Controls/PinIndicator/PinIndicator';
import './style.scss';

interface IProps {
  address: string | undefined;
}

/**
 * Render address and pin for current position
 *
 * @param address
 * @constructor
 */
const PlacePosition = ({ address }: IProps): JSX.Element => {
  return (
    <>
      {address ? <div className="place-position__address">{address}</div> : null}
      <PinIndicator name={Icons.Pin} size={50} className="color-red" iconClassName="text-center" />
    </>
  );
};

export default React.memo(PlacePosition);
